import i18next from 'i18next';
import {initReactI18next} from 'react-i18next';
//import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en.json';
import translationZH from './locales/zh.json';

// require.context("./locales/", true, /^.*/);

//i18next.use(Backend).use(LanguageDetector).use(initReactI18next).init({
i18next.use(LanguageDetector).use(initReactI18next).init({
        // load: 'languageOnly',
    debug: true,
    // backend: {
    //     loadPath:'/assets/i18n/{{lng}}.json'
    // },
    react: {
        wait: true,
        useSuspense: true
    },
    fallbackLng: 'en',
    // preload: [
    //     'en', 'zh'
    // ],
    keySeparator: false,
    interpolation: {
        escapeValue: false
    },
    resources:{
        en:{
            translation: translationEN
        },
        zh:{
            translation: translationZH
        }
    }
    
    // ,resources:{
    //     en: {
    //         translation:{
    //             email: "Email 111"
    //         }
    //     }
    // }
});

// console.log("i18next has been initialized..");

export default i18next;
